var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: ["kpi", { "kpi-big": _vm.big }, _vm.stateClass] }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            modifiers: { hover: true }
          }
        ],
        staticClass: "kpi-body",
        attrs: { title: _vm.kpi.extra_description }
      },
      [
        _c("Kpivalue", {
          attrs: {
            value: _vm.kpi.value,
            decimals: _vm.kpi.decimals_places,
            decimal_separator: ",",
            thousand_separators: ".",
            units: _vm.kpi.units,
            region: "es",
            classStyle: "kpi-title"
          }
        }),
        _vm._v(" "),
        _c("h6", { staticClass: "kpi-subtitle" }, [
          _vm._v(_vm._s(_vm.kpi.title))
        ]),
        _vm._v(" "),
        _c("i", { class: _vm.icon })
      ],
      1
    ),
    _vm._v(" "),
    (_vm.kpi.ref_time
    ? true
    : false)
      ? _c("div", { staticClass: "kpi-footer d-flex" }, [
          _c("div", { staticClass: "kpi-footer-left" }, [
            _vm._v(
              "\n        Reference last " +
                _vm._s(_vm.kpi.ref_time) +
                "\n      "
            )
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Modules/Kpi/Kpi.vue?vue&type=template&id=d1b7bd1e&
// module id = null
// module chunks = 